import { PropTypes } from 'prop-types';
import React from 'react';

import ArrowNormal from '../../assets/svg/arrow-normal.svg';

const LibrarySearchViewMore = ({ handleViewMore }) => {
  return (
    <button
      aria-label="View more search results"
      className="bg-snow py-4.5 px-8"
      onClick={handleViewMore}
      type="button"
    >
      <span className="stink-body-3">View more</span>
      <span className="ml-3">
        <ArrowNormal className="transform rotate-90 w-3.5 inline text-liquorice fill-current" />
      </span>
    </button>
  );
};

LibrarySearchViewMore.propTypes = {
  handleViewMore: PropTypes.func,
};

export default LibrarySearchViewMore;
